import React from 'react';

import { useField } from 'react-final-form';

import { Checkbox } from '@atlaskit/checkbox';

export const CheckboxField = (props: any) => {
  const { input } = useField(props.name, props);

  const handleChange = (event) => {
    const { target } = event;
    input.onChange(target.checked);
  };

  return <Checkbox isChecked={props.isChecked} onChange={handleChange} />;
};
